import React from "react";

import { Box, Button, Container, Typography } from "@mui/material";

import Header from "../Pages/Staking/Header";

import Footer from "../Components/Footer";
import { saveAs } from "file-saver";
import whitepaper from "../Components/images/whitepaper.pdf";

const WhitePaper = () => {
  const handleDownload = async () => {
    const fileUrl = whitepaper;

    const response = await fetch(fileUrl);
    const blob = await response.blob();
    saveAs(blob, "whitepaper.pdf");
  };
  return (
    <>
      <Box
        sx={{
          background: "#000",
          minHeight: { md: "100vh", xs: "auto" },
          height: "auto",
        }}
      >
        <Header />
        <Container sx={{ pb: 10 }}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap={4}
            pt={{ xs: 12, md: 25 }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: { md: "50px", sm: "40px", xs: "25px" },
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Defi Sage White Paper
            </Typography>

            <Box display="flex" gap={3} flexWrap="wrap" justifyContent="center">
              <Button
                onClick={handleDownload}
                sx={{
                  color: "white",
                  backgroundColor: "#B92D2E",
                  border: "2px solid gray",
                  borderRadius: "10px",
                  padding: "0.5rem 1rem",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#B92D2E",
                  },
                }}
              >
                Download The White Paper
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default WhitePaper;
